import TotalLibros from './TotalLibros';
import { TipoSeccionLibrosEstadisticas } from '@/objects/Telemetry';
import LibrosEstadisticasLista from './LibrosEstadisticasLista';
import { useNotificationContext } from '@/context/NotificationContext';
import { esPremium } from '@/util/StringsUtil';
import RowPremiumEstadisticas from './RowPremiumEstadisticas';
import { IDAdsense, SlotAnuncioDisplay } from '@/util/BaseURL';
import GoogleAds, { AdSenseFormat } from '../../Adsense/GoogleAds';

function EstadisticasGenerales() {
    const { userData } = useNotificationContext();

    return (
        <section style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
            {/* <TituloPrincipalH1 texto={t("menu:secciones.mensajes.titulo")} /> */}
            <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', width: "100%" }}>
                <div>
                    <GoogleAds client={IDAdsense} slot={SlotAnuncioDisplay} format={AdSenseFormat.HORIZONTAL} dataFullWidthResponsive={true} />
                </div>
                <TotalLibros />
                {!userData || !esPremium(userData.premium) && <RowPremiumEstadisticas />}
                <div>
                    <GoogleAds client={IDAdsense} slot={SlotAnuncioDisplay} format={AdSenseFormat.HORIZONTAL} dataFullWidthResponsive={true} />
                </div>
                <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.LIBROS_POPULARES} />
                {userData && esPremium(userData.premium) && <>
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.LIBROS_MAS_VENIDOS} />
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.LIBROS_MAS_FAVORITOS} />
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.AUTORES_POPULARES} />
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.EDITORIALES_POPULARES} />
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.LIBROS_MAS_CONTACTADOS} />
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.LIBROS_MAS_VISITADOS} />
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.BUSQUEDAS_CON_RESULTADOS} />
                    <LibrosEstadisticasLista tipoSeccionLibros={TipoSeccionLibrosEstadisticas.BUSQUEDAS_SIN_RESULTADOS} />
                </>
                }

            </section>
        </section>
    );
}

export default EstadisticasGenerales;